<template>
  <div class="PianMa">
    <!-- 冬季：10-12月 -->
    <div class="winter" v-if="(nowMoth >= 1 && nowMoth <= 2) || nowMoth==12">
      <div class="banner">
        <img width="100%" src="../../../assets/img/PianMa/winter_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/PianMa/winter_dangguiPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/PianMa/winter_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              当归具有补血活血，调经止痛，润肠通便之功效。常用于血虚萎黄，眩晕心悸，月经不调，经闭痛经，虛寒腹痛，风湿痹痛，跌扑损伤，痈疽疮疡，肠燥便秘。酒当归活血通经。用于经闭痛经，风湿痹痛，跌扑损伤。
            </p>
            <p>
              片马彝族乡种植有当归700余亩，主要品种为东当归，又叫大和归、日本当归、延边当归。预计今年我乡当归将实现亩产5000元，总产值可达350万元。
            </p>
            <p>
              片马彝族乡结合自身地理位置优势，大力发展特色中药材产业，其中牛膝种植面积将近500亩。牛膝性味苦、甘、酸、平，入肝、肾经，具有活血通经、补肝肾、利水通淋、引火(血)下行等功效。牛膝去杂质，用水冲洗净，润透后切段，放入锅中加入适量的水，熬制后即可食用。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/PianMa/winter_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/PianMa/winter_square.png')" color="#7F3D2A"
        borderBottomColor="#7F3D2A" boxBorderColor="#DFD6D3" btnBJcolor="#BE9E95" hoverBJcolor="#844533">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/PianMa/winter_square.png')" color="#7F3D2A"
        borderBottomColor="#7F3D2A"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/PianMa/winter_square.png')" color="#7F3D2A"
        borderBottomColor="#7F3D2A" boxBorderColor="#DFD6D3"></ztxzList>
    </div>    
    <!-- 四季 -->
    <div class="autumn" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/PianMa/banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/PianMa/huajiaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/PianMa/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              近年来，汉源县片马彝族乡围绕建设“灵秀片马、核桃之乡”的目标，把核桃产业作为助力脱贫攻坚、助推乡村振兴的优势主导产业，依托得天独厚的地域优势、气候条件，深挖片马核桃千年种植历史，聚力建基地、搞加工、创品牌、促融合，全产业链发展核桃产业，打造“小核桃大产业”!
            </p>
            <p>
              近年来，片马彝族乡紧紧围绕“一核多元”的产业发展模式，在大力发展2.5万亩核桃产业的基础上，积极推进花椒、中药材、脆红李等特色农产品的种植。目前，片马彝族乡共种植花椒5000余亩，品种有青花椒、红花椒两大种类，青花椒属灌木，果皮可作为调味料，可提取芳香油，又可入药。种子可食用，又可加工制作肥皂。具有降低血压、增加食欲、驱虫等功效。红花椒是芸香料花椒的干燥成熟果皮，外表面深红色、紫红色或棕红色，皱缩，有众多点状凸起的油点，果皮革质，稍韧，有特异香气，味持久麻辣。具有杀菌止痛、杀虫止痒等功效。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/PianMa/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/PianMa/square.png')" color="#163D96"
        borderBottomColor="#163D96" boxBorderColor="#D1D7E7" btnBJcolor="#8A9DC8" hoverBJcolor="#1B4098">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/PianMa/square.png')" color="#163D96"
        borderBottomColor="#163D96"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/PianMa/square.png')" color="#163D96"
        borderBottomColor="#163D96" boxBorderColor="#D1D7E7"></ztxzList>
    </div>

  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'PianMa',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'片马彝族乡'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.PianMa {
  background: url('../../../../src/assets/img/PianMa/PianMa_bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.autumn .top_title {
  color: #38489A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #38489A;
  height: 12%;
}

.winter .top_title {
  color: #7F3D2A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #7F3D2A;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>